import React from 'react';
import { ToastWrapper } from './ToastStyles';

const Toast = ({ heading, message }) => {
  return (
    <ToastWrapper>
      <h5 className={heading}>{heading}</h5>
      <p>{message}</p>
    </ToastWrapper>
  );
};

export default Toast;
